import React from "react";
import {
  FiEdit2,
  FiEye,
  FiImage,
  FiToggleLeft,
  FiToggleRight,
  FiTrash2,
} from "react-icons/fi";

import { toAbsolutePublicUrl } from "../../../../services/mediaLibraryServices";

import AdminButton from "./../../_shared/ui/AdminButton";
import AdminStatusBadge from "./../../_shared/ui/AdminStatusBadge";

import { formatShortDate, truncateText } from "../utils/newsAdminUtils";

export default function NewsCard({
  item,
  actionId,
  onPreview,
  onEdit,
  onToggle,
  onAskDelete,
}) {
  const imageUrl = item?.image_url ? toAbsolutePublicUrl(item.image_url) : "";
  const toggleLoading = actionId === `toggle-${item.id}`;

  return (
    <article className="group overflow-hidden rounded-[1.7rem] border border-slate-200 bg-slate-50 transition hover:-translate-y-0.5 hover:border-sky-200 hover:bg-white hover:shadow-xl hover:shadow-slate-200/60 dark:border-slate-800 dark:bg-slate-950 dark:hover:border-sky-500/30 dark:hover:bg-slate-900 dark:hover:shadow-black/20">
      <div className="grid min-h-full sm:grid-cols-[190px_1fr]">
        <div className="relative min-h-[190px] overflow-hidden bg-slate-200 dark:bg-slate-800">
          {imageUrl ? (
            <img
              src={imageUrl}
              alt={item.title}
              className="h-full w-full object-cover transition duration-500 group-hover:scale-105"
            />
          ) : (
            <div className="flex h-full min-h-[190px] flex-col items-center justify-center gap-3 bg-gradient-to-br from-slate-100 to-slate-200 text-slate-400 dark:from-slate-800 dark:to-slate-900 dark:text-slate-500">
              <FiImage className="text-4xl" />
              <span className="text-xs font-bold uppercase tracking-[0.18em]">
                Sans image
              </span>
            </div>
          )}

          <div className="absolute left-3 top-3">
            <AdminStatusBadge active={!!item.is_active} />
          </div>
        </div>

        <div className="flex min-w-0 flex-col p-4 sm:p-5">
          <div className="min-w-0 flex-1">
            <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-400 dark:text-slate-500">
              {formatShortDate(item.created_at)}
            </p>

            <h3 className="mt-2 line-clamp-2 text-lg font-bold leading-snug text-slate-950 dark:text-white">
              {item.title || "Sans titre"}
            </h3>

            <p className="mt-3 line-clamp-3 text-sm leading-6 text-slate-600 dark:text-slate-300">
              {truncateText(item.content, 210) || "Aucun contenu renseigné."}
            </p>
          </div>

          <div className="mt-5 flex flex-wrap gap-2">
            <AdminButton
              icon={FiEye}
              variant="secondary"
              size="sm"
              onClick={() => onPreview(item.id)}
            >
              Voir
            </AdminButton>

            <AdminButton
              icon={FiEdit2}
              variant="soft"
              size="sm"
              onClick={() => onEdit(item.id)}
            >
              Modifier
            </AdminButton>

            <AdminButton
              icon={item.is_active ? FiToggleLeft : FiToggleRight}
              variant={item.is_active ? "secondary" : "primary"}
              size="sm"
              loading={toggleLoading}
              onClick={() => onToggle(item.id)}
            >
              {item.is_active ? "Masquer" : "Publier"}
            </AdminButton>

            <AdminButton
              icon={FiTrash2}
              variant="dangerSoft"
              size="sm"
              onClick={() => onAskDelete(item.id)}
            >
              Supprimer
            </AdminButton>
          </div>
        </div>
      </div>
    </article>
  );
}